<template>
  <div class="modal apinquiry-modal">
    <!-- 개인정보 동의 팝업-->
    <HomeAgreeInfoModal v-if="isOpenAgree" :infotext="infoText" @close-modal="onCloseModal">
      <template #homegreeinfotext3="{text4}">
        {{ text4 }}
      </template>
    </HomeAgreeInfoModal>

    <div class="apinquiry-container">
      <!-- close-wrap-->
      <div class="flex_end">
        <a tabindex="0" class="common-close-md cursor" @click="onClickClose">
          <img class="common-close-md" src="/media/images/icon/close-lg-icon.png" alt="close-lg-icon.png" />
        </a>
      </div>
      <!-- apinquiry-header -->
      <div class="apinquiry-header">
        <h1 class="apinquiry-title">문의</h1>
      </div>

      <!-- apinquiry-selecttabwrap -->
      <div class="apinquiry-selecttabwrap">
        <InquirySelectTab :selecttab="selectTab" @click-tab="onClickSelectTab">
          <template #firstitem>제휴 문의</template>
          <template #seconditem>1:1 문의</template>
        </InquirySelectTab>
      </div>

      <!-- apinquiry-form -->
      <div class="apinquiry-form">
        <!-- 이름(공통) -->
        <div class="apinquiry-inputwrap">
          <InputBox
            :placeholder="nameplaceholder.default"
            :value="inquiryData.partnerNm"
            @change-input="val => onChangeInput(val, 'partnerNm')"
          />
        </div>

        <!-- 소속(제휴) -->
        <div class="apinquiry-inputwrap" v-if="selectTab === 1">
          <InputBox
            :placeholder="companyplaceholder.default"
            :value="inquiryData.partnerCompany"
            @change-input="val => onChangeInput(val, 'partnerCompany')"
          />
        </div>
        <!-- 이메일(1:1)-->
        <div class="apinquiry-inputwrap" v-if="selectTab === 2">
          <InputBox
            :placeholder="emailplaceholder.default"
            :value="inquiryData.partnerEmail"
            @change-input="val => onChangeInput(val, 'partnerEmail')"
          />
        </div>

        <!-- 이메일주소(제휴)-->
        <div class="apinquiry-inputwrap" v-if="selectTab === 1">
          <InputBox
            :placeholder="emailplaceholder.default"
            :value="inquiryData.partnerEmail"
            @change-input="val => onChangeInput(val, 'partnerEmail')"
          />
        </div>
        <!-- 연락처('-'제외)(1:1)-->
        <div class="apinquiry-inputwrap" v-if="selectTab === 2">
          <InputBox
            :placeholder="phoneplaceholder.default"
            :inputtype="'number'"
            :value="inquiryData.partnerPhone"
            @change-input="val => onChangeInput(val, 'partnerPhone')"
          />
        </div>

        <!-- 연락처('-'제외)(제휴)-->
        <div class="apinquiry-inputwrap" v-if="selectTab === 1">
          <InputBox
            :placeholder="phoneplaceholder.default"
            :inputtype="'number'"
            :value="inquiryData.partnerPhone"
            @change-input="val => onChangeInput(val, 'partnerPhone')"
          />
        </div>
        <!--문의제목 (1:1)-->
        <div class="apinquiry-inputwrap" v-if="selectTab === 2">
          <InputBox
            :placeholder="titleplaceholder.default"
            :value="inquiryData.partnerTitle"
            @change-input="val => onChangeInput(val, 'partnerTitle')"
          />
        </div>
        <!-- 문의내용(공통)-->
        <div class="apinquiry-inputwrap">
          <div class="apinquiry-contents-wrap">
            <textarea
              class="apinquiry-contents"
              :placeholder="contentplaceholder.default"
              name="contents"
              v-model="inquiryData.partnerContent"
              id="contents"
              resize="none"
              @input="onChangeTextArea"
            ></textarea>
            <div class="apinquiry-contents-textcount">{{ textCount }}/{{ contentsmax }}</div>
          </div>
        </div>

        <!-- agreebox-->
        <div class="agreebox">
          <div class="agreebox-left">
            <img
              class="agree-checkbox cursor"
              @click="isAgreeChecked = !isAgreeChecked"
              :src="
                isAgreeChecked
                  ? '/media/images/icon/check-red-lg-icon.png'
                  : '/media/images/icon/check-gray-lg-icon.png'
              "
              alt="check-gray-icon.png"
            />
            <span class="agreebox-left-text cursor" @click="isAgreeChecked = !isAgreeChecked"
              >개인정보 수집 및 이용에 동의합니다</span
            >
          </div>
          <div class="agreebox-right">
            <a tabindex="0" class="check-agreecontents cursor" @click="isOpenAgree = true">
              내용확인
            </a>
          </div>
        </div>
      </div>

      <!-- submit btn-->
      <div class="submit-btnwrap">
        <BasicButton :disabled="btnDisabled" :boxsize="'md'" @click-btn="sendInquiry">
          <template #btnname>
            문의하기
          </template>
        </BasicButton>
      </div>
    </div>
  </div>
</template>
<script>
import InquirySelectTab from './InquirySelectTab.vue';
import InputBox from '../../InputBox/InputBox.vue';
import BasicButton from '../../BasicButton/BasicButton.vue';
import HomeAgreeInfoModal from '../../home/HomeAgreeInfoModal.vue';
import { createPartnership } from '@/service/api/menuApi';
export default {
  components: {
    InquirySelectTab,
    InputBox,
    BasicButton,
    HomeAgreeInfoModal
  },
  emits: ['close-modal', 'complete-inquiry'],
  data() {
    return {
      isComplete: false,
      inquiryData: {
        partnerCompany: '',
        partnerTitle: '',
        partnerNm: '',
        partnerEmail: '',
        partnerContent: '',
        partnerPhone: ''
      },
      inquiryText: '',
      isAgreeChecked: false,
      isOpenAgree: false,
      infoText: '제휴 문의',
      selectTab: 1,
      nameplaceholder: {
        type: String,
        required: false,
        default: '이름'
      },
      companyplaceholder: { default: '소속' },
      emailplaceholder: { default: '이메일주소' },
      phoneplaceholder: { default: '연락처 (‘-’제외)' },
      titleplaceholder: { default: '문의제목' },
      contentplaceholder: { default: '문의내용' },
      contentsmax: 1000
    };
  },
  methods: {
    async sendInquiry() {
      const sendObj = {};
      Object.keys(this.inquiryData).forEach(item => {
        sendObj[item] = this.inquiryData[item];
      });
      if (this.selectTab === 1) {
        sendObj.partnerCategory = 'P';
        delete sendObj.partnerTitle;
      } else {
        sendObj.partnerCategory = 'N';
      }
      try {
        const { data } = await createPartnership(sendObj);
        const { resultCd } = data;
        if (resultCd === '0000') {
          this.$emit('complete-inquiry');
        }
      } catch (error) {
        console.log(error);
      }
    },

    onChangeTextArea($event) {
      if ($event.target) {
        this.inquiryData.partnerContent = $event.target.value;
        if (this.inquiryData.partnerContent.length > this.contentsmax) {
          this.inquiryData.partnerContent = this.inquiryData.partnerContent.slice(0, this.contentsmax);
          $event.target.value = this.inquiryData.partnerContent;
        }
      }
    },
    onChangeInput(val, key) {
      this.inquiryData[key] = val;
    },
    onClickSelectTab(val) {
      if (val === this.selectTab) return;
      this.selectTab = val;
      this.isAgreeChecked = false;
      Object.keys(this.inquiryData).forEach(item => {
        this.inquiryData[item] = '';
      });
      if (val === 1) {
        this.infoText = '제휴 문의';
      } else {
        this.infoText = '1:1 문의';
      }
    },
    onClickClose() {
      this.$emit('close-modal');
    },
    onCloseModal() {
      this.isOpenAgree = false;
    }
  },
  computed: {
    textCount() {
      return this.inquiryData.partnerContent.length;
    },
    btnDisabled() {
      const { partnerNm, partnerCompany, partnerTitle, partnerEmail, partnerPhone, partnerContent } = this.inquiryData;
      if (this.selectTab === 1) {
        if (
          partnerNm.length > 0 &&
          partnerCompany.length > 0 &&
          partnerEmail.length > 0 &&
          partnerPhone.length > 0 &&
          partnerContent.length > 0 &&
          this.isAgreeChecked
        ) {
          return false;
        }
      } else {
        if (
          partnerNm.length > 0 &&
          partnerEmail.length > 0 &&
          partnerPhone.length > 0 &&
          partnerTitle.length > 0 &&
          partnerContent.length > 0 &&
          this.isAgreeChecked
        ) {
          return false;
        }
      }
      return true;
    }
  }
};
</script>
<style scoped src="@/assets/css/apinquirymodal/apinquirymodal.css"></style>
